/**
 * B2B Quantity Selector — shared logic for PLP + PDP.
 * Handles +/- taps, manual input, and syncs with the form's hidden
 * quantity field on PDP.
 *
 * All new code is vanilla JS. Legacy jQuery handlers retained where
 * they interact with existing jQuery-dependent global_js.liquid code.
 */
(function () {
    'use strict';
  
    /**
     * Clamp a value between min and max.
     * @param {number} val
     * @param {number} min
     * @param {number} max
     * @returns {number}
     */
    function clamp(val, min, max) {
      if (val < min) {
        return min;
      }
      if (max && val > max) {
        return max;
      }
      return val;
    }
  
    /**
     * Get min/max from the input element attributes.
     * @param {HTMLInputElement} input
     * @returns {{ min: number, max: number|null }}
     */
    function getLimits(input) {
      var min = parseInt(input.getAttribute('min'), 10) || 1;
      var maxAttr = input.getAttribute('max');
      var max = maxAttr ? parseInt(maxAttr, 10) : null;
      return { min: min, max: max };
    }
  
    /**
     * Update the input value and fire a change event.
     * @param {HTMLInputElement} input
     * @param {number} newVal
     */
    function setInputValue(input, newVal) {
      var limits = getLimits(input);
      var clamped = clamp(newVal, limits.min, limits.max);
      input.value = clamped;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  
    /**
     * Find the sibling qty input relative to a +/- button.
     * @param {HTMLElement} button
     * @returns {HTMLInputElement|null}
     */
    function getSiblingInput(button) {
      var parent = button.parentElement;
      if (!parent) {
        return null;
      }
      return parent.querySelector('[data-b2b-qty-input]');
    }
  
    /* ---- Minus button (click + touchend for mobile) ---- */
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-b2b-qty-minus]');
      if (!btn) {
        return;
      }
      e.preventDefault();
      e.stopPropagation();
      var input = getSiblingInput(btn);
      if (input) {
        setInputValue(input, (parseInt(input.value, 10) || 1) - 1);
      }
    });
  
    /* ---- Plus button (click + touchend for mobile) ---- */
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-b2b-qty-plus]');
      if (!btn) {
        return;
      }
      e.preventDefault();
      e.stopPropagation();
      var input = getSiblingInput(btn);
      if (input) {
        setInputValue(input, (parseInt(input.value, 10) || 1) + 1);
      }
    });
  
    /* ---- Manual input clamp (fires on both input and change) ---- */
    document.addEventListener('input', handleInputClamp);
    document.addEventListener('change', handleInputClamp);
  
    /**
     * Clamp qty input value and sync to PDP hidden field.
     * @param {Event} e
     */
    function handleInputClamp(e) {
      var input = e.target;
      if (!input.matches || !input.matches('[data-b2b-qty-input]')) {
        return;
      }
      var limits = getLimits(input);
      var raw = input.value.replace(/[^0-9]/g, '');
      var val = parseInt(raw, 10);
      if (isNaN(val) || val < limits.min) {
        input.value = limits.min;
      } else if (limits.max && val > limits.max) {
        input.value = limits.max;
      } else {
        input.value = raw;
      }
  
      /* PDP sync: push value into the form's hidden quantity input */
      var wrapper = input.closest('[data-b2b-qty]');
      if (wrapper && wrapper.getAttribute('data-context') === 'pdp') {
        var form = input.closest('form');
        if (!form) {
          var productForm = input.closest('.product__form');
          form = productForm ? productForm.querySelector('form') : null;
        }
        if (form) {
          var hiddenQty = form.querySelector('input.quantity__input');
          if (hiddenQty) {
            hiddenQty.value = input.value;
          }
        }
      }
    }
  
    /* ---- Block non-numeric keystrokes in number inputs ---- */
    document.addEventListener('keydown', function (e) {
      if (!e.target.matches || !e.target.matches('[data-b2b-qty-input]')) {
        return;
      }
      /* Allow: backspace, delete, tab, escape, enter, arrow keys, home, end */
      var allowedKeys = [8, 9, 27, 13, 46, 37, 38, 39, 40, 35, 36];
      if (allowedKeys.indexOf(e.which) !== -1) {
        return;
      }
      /* Block anything outside 0-9 (both main keyboard and numpad) */
      if ((e.which < 48 || e.which > 57) && (e.which < 96 || e.which > 105)) {
        e.preventDefault();
      }
    });
  
    /**
     * Capture-phase click listener: prevent the ancestor <a> from navigating
     * when a click (or mobile synthetic click after touch) originates inside
     * the qty selector. Only targets click — NOT touchend — because calling
     * preventDefault on touchend suppresses the subsequent synthetic click,
     * which breaks +/- button handlers on mobile.
     */
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('[data-b2b-qty]')) {
        var anchor = e.target.closest('a');
        if (anchor) {
          e.preventDefault();
        }
      }
    }, true);
  
    /**
     * touchstart on the qty wrapper: stopPropagation only (no preventDefault)
     * so the touch sequence completes normally and the synthetic click fires.
     * This prevents the parent card's touch handlers from interfering.
     */
    document.addEventListener('touchstart', function (e) {
      if (e.target.closest && e.target.closest('[data-b2b-qty]')) {
        e.stopPropagation();
      }
    }, true);
  
    /**
     * touchend on the qty wrapper: stopPropagation only. Do NOT call
     * preventDefault here — that would kill the synthetic click event
     * that mobile browsers generate after touch, breaking all click
     * handlers inside the selector.
     */
    document.addEventListener('touchend', function (e) {
      if (e.target.closest && e.target.closest('[data-b2b-qty]')) {
        e.stopPropagation();
      }
    }, true);
  })();